<template>
  <div>
    <h2 class="uppercase mt-24 text-xl tracking-widest">
      {{$t('password.accessData')}}
    </h2>
    <div class="flex justify-between items-center mb-20">
      <material-label class="mt-6 mr-6 w-full" name="Email" :value="user.email" />
       <button
        class="hover:text-b2c-red-300 transform rounded p-1 mt-10
          flex items-center justify-end text-sm w-full"
        @click="changePassword=!changePassword">
          <span class="px-2"> {{$t('password.changePassword')}}</span>
          <dropdown-arrow />
        </button>
    </div>

    <div v-if="changePassword" class="w-3/4 md:w-1/2 mb-20">
      <div>
        <material-input-password class="mt-10 pt-1" :name="$t('password.old')"
           v-model="updatePassword.oldPassword"
           @keyup.native="resetErrorField('oldPassword')"/>
        <span class="text-red-500"
          v-if="errors.has('oldPassword')"
          v-text="errors.get('oldPassword')"
        >
        </span>
      </div>
      <div>
        <material-input-password class="mt-4 pt-1" :name="$t('password.new')"
          v-model="updatePassword.newPassword"
          @keyup.native="resetErrorField('newPassword')"/>
        <span class="text-red-500"
          v-if="errors.has('newPassword')"
          v-text="errors.get('newPassword')"
        >
        </span>
      </div>
      <div>
        <material-input-password class="mt-4 pt-1" :name="$t('password.newConfirm')"
          v-model="updatePassword.confirmNewPassword"
          @keyup.native="resetErrorField('confirmNewPassword')"/>
        <span class="text-red-500"
          v-if="errors.has('confirmNewPassword')"
          v-text="errors.get('confirmNewPassword')"
        >
        </span>
      </div>

      <button
        class="hidden md:block shadow-md cursor-pointer hover:border-gray-600 border
        rounded-md p-2 px-3 mt-10"
        @click="saveNewPassword"
        :class="isLoading ? 'loader' : ''">
          {{$t('password.savePassword')}}
      </button>
      <button
        class="md:hidden text-white rounded p-2 px-3 mt-10"
        @click="saveNewPassword"
        :class="isLoading ? 'loader' : ''">
          {{$t('password.savePassword')}}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import Errors from '@/util/Errors';
import MaterialInputPassword from '@/components/graphics/MaterialInputPassword.vue';
import MaterialLabel from '@/components/graphics/MaterialLabel.vue';
import DropdownArrow from '@/components/graphics/DropdownArrow.vue';

export default {
  data() {
    return {
      changePassword: false,
      updatePassword: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      },
      isLoading: false,
      errors: new Errors(),
    };
  },

  components: {
    MaterialInputPassword,
    DropdownArrow,
    MaterialLabel,
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  methods: {
    resetErrorField(field) {
      this.errors.clear(field);
    },
    saveNewPassword() {
      this.isLoading = true;
      axios.put(`/api/users/${this.user.id}/password`, this.updatePassword).then(({ data }) => {
        this.changePassword = false;
        this.updatePassword.oldPassword = '';
        this.updatePassword.newPassword = '';
        this.updatePassword.confirmNewPassword = '';
        this.isLoading = false;
        this.createNotification('success', data);
      }).catch(({ response: { data: { errors } } }) => {
        this.isLoading = false;
        this.errors.record(errors);
      });
    },
  },

};
</script>
